<template>
  <div
  	class="chat-container w-100 position-relative bg-light"
  	style="min-height: 100%;height: 100vh;margin-bottom: -60px!important"
  	:class="{'bg-white h-auto':detail_tx != '' || is_load}">
    <div id="hotel-history"></div>
    <div>
	    <!-- LIST ORDER-->
	    <template v-if="detail_tx == ''">
	    	<!-- HEADER LIST ORDER -->
		    <div class="position-relative z-index-1028">
		      <div class="row no-gutters justify-content-center">
		        <div class="fixed-top d-block nav-bottom">
		          <div class="custom-container-fluid px-0">
		            <div class="row justify-content-center no-gutters">
		              <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
		                <div class="bg-white" :class="{'box-shadow-nav':scrollPosition >40}">
		                  <div class="container px-4 w-100 py-1">
		                    <div class="row no-gutters py-2 m-0 w-100">
		                      <div class="col-1">
		                        <div class="">
		                          <router-link :to="'/'+getMerchant().code+'/account'">
		                            <img src="../../../assets/img/icon/back.png" class="mt-2" width="20">
		                          </router-link>
		                        </div>
		                      </div>
		                      <div class="col-8">
		                        <div class="">
		                          <p class="mb-0 body-1-2 nav-hotel ml-3 mt-1">{{$t("general.order-history")}}</p>
		                        </div>
		                      </div>
		                      <div class="col-3 text-right">
		                        <div class="mt-1">
		                          <router-link :to="'/'+getMerchant().code+'/account'">
										    				<div class="">
										              <img
										              	v-if="!isNotLogin()" style="padding: 2px"
										              	:src="getCurrentUser().avatar"
										              	width="30"
										              	height="30"
										              	class="rounded-100 border-2-green object-fit">
										              <img
										              	v-else
										              	src="../../../assets/img/icon/user.png"
										              	width="30"
										              	height="30"
										              	class="rounded-100 p-1 object-fit"
										              	style="background-color: #cfcfcf">
										            </div>
										          </router-link>
		                        </div>
		                      </div>
		                    </div>
		                  </div>
		                </div>
		              </div>
		            </div>
		          </div>
		        </div>
		      </div>
		    </div>
		    <div class="container px-4">
		    	<div style="height: 58px"></div>
		    	<!-- FILTER -->
		    	<div class="row slim-grid-row my-3 py-2">
	          <div class="col-7">
	            <p class="body-3-1 text-14 mb-0 position-relative" style="top: 2px">{{$t("hotel.tap-list-to-see-order-detail")}}</p>
	          </div>
	          <div class="col-5 text-right">
	            <p class="body-3-1 mb-0 text-14 d-inline-block mr-1 mb-2 cursor-pointer" @click="isFilter()">{{$t("hotel.filter.filter")}}</p>
	            <div class="d-inline-block delay" :class="{'rotate-90':is_filter}">
	              <i class="simple-icon-equalizer bg-white p-2 box-shadow-main rounded-100 cursor-pointer" @click="isFilter()"></i>
	            </div>
	          </div>
	          <transition name="fade">
	            <div class="col-12 my-2" v-if="is_filter">
	              <div class="row slim-grid-row">
	                <div class="col-6">
	                  <p class="mb-1 body-2-2 text-12">{{$t("hotel.payment-method.status")}}:</p>
	                  <v-select
	                  	type="text"
	                  	class="general-select-border w-100 bg-white body-2-2 rounded-3 box-shadow-main"
	                  	:options="v_status"
	                  	:clearable="false"
	                  	v-model="status_selected"
	                  	@input="toggleFilter">
		                  	<template #selected-option="v_status">
			                    <span>{{$t('option.'+v_status.label+'')}}</span>
			                  </template>
			                  <template v-slot:option="v_status">
			                    <span>{{$t('option.'+v_status.label+'')}}</span>
			                  </template>
	                  	</v-select>
	                </div>
	                <div class="col-6">
	                  <p class="mb-1 body-2-2 text-12">{{$t("hotel.sort-by")}}:</p>
	                  <v-select
	                  	type="text"
	                  	class="general-select-border w-100 bg-white body-2-2 rounded-3 box-shadow-main"
	                  	:options="v_sort"
	                  	:clearable="false"
	                  	v-model="sort_selected"
	                  	@input="toggleSort">
	                  		<template #selected-option="v_sort">
	                  			<span>{{$t('option.'+v_sort.label+'')}}</span>
	                  		</template>
	                  		<template v-slot:option="v_sort">
	                  			<span>{{$t('option.'+v_sort.label+'')}}</span>
	                  		</template>
	                  	</v-select>
	                </div>
	              </div>
	            </div>
	          </transition>
	        </div>
		    </div>
		    <div v-if="is_load" class="w-100 my-5 text-center">
		      <loader />
		    </div>
		    <div v-else>
			    <div class="container px-4 pb-3 bg-light">
		        <template v-if="total != 0">
		        	<!-- ORDER LIST -->
		          <div class="mb-4 p-3 rounded-6 bg-white box-shadow-main cursor-pointer" id="list" v-if="data.user.id == user.id && getMerchant().id == data.data_detail.merchant_id" v-for="(data, index) in tx" @click="detailTx(data)">
		            <div class="">
		              <div class="row">
		                <div class="col-6">
		                  <p class="mb-0 body-2-2 font-bold">{{data.invoice}}</p>
		                </div>
		                <div class="col-6 text-right">
		                  <p class="mb-0 body-2-2 font-semibold text-12 text-orange" v-if="data.status == 'WAITING_PAYMENT_CONFIRMATION'">{{$t("hotel.waiting.waiting-payment")}}</p>
		                  <p class="mb-0 body-2-2 font-semibold text-14 text-green" v-if="data.status == 'COMPLETE'">{{$t("hotel.success.success")}}</p>
		                  <p class="mb-0 body-2-2 font-semibold text-14 text-danger" v-if="data.status == 'CANCELLED'">{{$t("hotel.failed.failed")}}</p>
		                </div>
		              </div>
		            </div>
		            <div class="mt-2">
		              <div class="row">
		              	<div class="col-6 mb-2">
		                  <p class="mb-0 body-3">{{$t("hotel.date.check-in")}}:</p>
		                  <p class="mb-0 body-3-1 text-truncate">{{formatDate(data.check_in_date)}}</p>
		                </div>
		                <div class="col-6 mb-2">
		                  <p class="mb-0 body-3">{{$t("hotel.date.check-out")}}:</p>
		                  <p class="mb-0 body-3-1 text-truncate">{{formatDate(data.check_out_date)}}</p>
		                </div>
		                <div class="col-6 mb-2">
		                  <p class="mb-0 body-3">{{$t("hotel.success.transaction-date")}}</p>
		                  <p class="mb-0 body-3-1">{{formatDate(data.created_at)}}</p>
		                </div>
		                <div class="col-6 mb-2">
		                  <p class="mb-0 body-3">{{$t("hotel.total")}}:</p>
		                  <p class="mb-0 body-3-1 text-truncate">{{formatCurrency(data.data_detail.payments.total_payment)}}</p>
		                </div>
		              </div>
		            </div>
		          </div>
		          <!-- PAGINATION -->
		          <div class="overflow-auto mx-auto text-center mt-2" v-if="total > perPage">
			          <b-pagination
			          	class="d-inline-block"
						      v-model="currentPage"
						      :total-rows="total"
						      :per-page="perPage"
						    ></b-pagination>
						  </div>
		        </template>
		        <!-- EMPTY -->
		        <template v-else>
			        <div class="container px-5 pt-4 text-center">
			          <img src="../../../assets/img/icon/404.png" width="170" class="text-center">
			          <p class="mb-0 mt-3 body-2-2 font-semibold">{{$t("option.no-order")}}</p>
			        </div>
			      </template>
			    </div>
			  </div>
		  </template>
	    <!-- DETAIL ORDR -->
	    <template v-else>
				<div class="container px-4 pt-3 pb-2 sticky bg-white" :class="{'box-shadow-nav':scrollPosition >30}" style="top:0">
	        <img src="../../../assets/img/icon/close.png" class="my-2 d-inline-block mr-2 cursor-pointer" width="15" @click="detailTx(false)">
	        <p class="mb-0 body-2-2 text-16 font-bold d-inline-block">{{$t('hotel.order-details')}}</p>
	      </div>
	      <!-- Orders Details -->
	      <div class="container py-3 px-4">
					<div>
	          <p class="mb-2 body-2-2 text-16 font-bold">{{d.merchant_name}}</p>
	          <div class="row">
	          	<div class="col-6 mb-2">
	          		<p class="mb-0 body-2 font-regular text-12">{{$t("hotel.success.order-id")}}</p>
	          		<p class="mb-0 body-2-2 text-14 font-semibold">{{detail_tx.invoice}}</p>
	          	</div>
	          	<div class="col-6 mb-2">
	          		<p class="mb-0 body-2 font-regular text-12">{{$t("hotel.success.transaction-date")}}</p>
	          		<p class="mb-0 body-2-2 text-14 font-semibold">{{formatDate(detail_tx.created_at)}}</p>
	          	</div>
	          	<div class="col-12 mb-2">
	              <p class="mb-0 body-2 font-regular text-12">{{$t("hotel.rooms")}}</p>
	              <template v-for="room in d.transaction_details">
	              	<p class="mb-0 body-2-2 text-14 font-semibold">{{room.name}} x {{room.qty}}
	              		<span v-if="room.qty > 1">{{$t("hotel.rooms")}}</span>
	              		<span v-else>{{$t("hotel.room")}}</span>
	              	</p>
	              </template>
	            </div>
	          	<div class="col-12 mb-2">
	              <p class="mb-0 body-2 font-regular text-12">{{$t("hotel.guests.guests")}}</p>
	              <p class="mb-0 body-2-2 text-14 font-semibold">{{d.transaction_details[0].adult}} {{$t("hotel.adults.adults")}}, {{d.transaction_details[0].child}} {{$t("hotel.children.children")}}, {{d.transaction_details[0].infant}} {{$t("hotel.infants.infants")}}</p>
	            </div>
	            <div class="col-6 mb-2">
	              <p class="mb-0 body-2 font-regular text-12">{{$t("hotel.date.check-in")}}</p>
	              <p class="mb-0 body-2-2 text-14 font-semibold">{{formatDate(d.transaction_details[0].check_in_date)}}</p>
	            </div>
	            <div class="col-6 mb-2">
	              <p class="mb-0 body-2 font-regular text-12">{{$t("hotel.date.check-out")}}</p>
	              <p class="mb-0 body-2-2 text-14 font-semibold">{{formatDate(d.transaction_details[0].check_out_date)}}</p>
	            </div>
	          </div>
	          <!-- Contact Detail -->
	          <template v-if="d.customer_details.first_name != d.visitor_details.first_name && d.customer_details.email != d.visitor_details.email">
	            <p class="mt-4 mb-2 body-2-2 text-16 font-bold">{{$t("hotel.contact-detail.title")}}</p>
	            <div class="row">
	              <div class="col-12 mb-2">
	                <p class="mb-0 body-2 font-regular text-12">{{$t("ticket-cart.name")}} :</p>
	                <p class="mb-0 body-2-2 text-14 font-semibold">{{d.customer_details.title}} {{d.customer_details.first_name}} {{d.customer_details.last_name}}</p>
	              </div>
	              <div class="col-6 mb-2">
	                <p class="mb-0 body-2 font-regular text-12">{{$t("hotel.visitor-detail.phone-number")}} :</p>
	                <p class="mb-0 body-2-2 text-14 font-semibold">{{d.customer_details.phone_number}}</p>
	              </div>
	              <div class="col-6 mb-2">
	                <p class="mb-0 body-2 font-regular text-12">{{$t("hotel.visitor-detail.email")}} :</p>
	                <p class="mb-0 body-2-2 text-14 font-semibold text-truncate">{{d.customer_details.email}}</p>
	              </div>
	              <div class="col-6 mb-2">
	                <p class="mb-0 body-2 font-regular text-12">{{$t("hotel.visitor-detail.address")}} :</p>
	                <p class="mb-0 body-2-2 text-14 font-semibold">{{d.customer_details.address}}</p>
	              </div>
	              <div class="col-6 mb-2">
	                <p class="mb-0 body-2 font-regular text-12">{{$t("hotel.visitor-detail.country")}} :</p>
	                <p class="mb-0 body-2-2 text-14 font-semibold">{{d.customer_details.country}}</p>
	              </div>
	            </div>
	          </template>
	          <!-- Visitor Detail -->
	          <template>
	            <p class="mt-4 mb-2 body-2-2 text-16 font-bold" v-if="is_valid_visitor">{{$t("hotel.visitor-detail.visitor-detail")}}</p>
	            <div class="row">
	              <div class="col-12 mb-2">
	                <p class="mb-0 body-2 font-regular text-12" v-if="d.visitor_details.first_name != ''">{{$t("ticket-cart.name")}} :</p>
	                <p class="mb-0 body-2-2 text-14 font-semibold" v-if="d.visitor_details.first_name != ''">{{d.visitor_details.title}} {{d.visitor_details.first_name}} {{d.visitor_details.last_name}}</p>
	              </div>
	              <div class="col-6 mb-2" v-if="d.visitor_details.phone_number != ''">
	                <p class="mb-0 body-2 font-regular text-12">{{$t("hotel.visitor-detail.phone-number")}} :</p>
	                <p class="mb-0 body-2-2 text-14 font-semibold">{{d.visitor_details.phone_number}}</p>
	              </div>
	              <div class="col-6 mb-2" v-if="d.visitor_details.email != ''">
	                <p class="mb-0 body-2 font-regular text-12">{{$t("hotel.visitor-detail.email")}} :</p>
	                <p class="mb-0 body-2-2 text-14 font-semibold text-truncate">{{d.visitor_details.email}}</p>
	              </div>
	              <div class="col-6 mb-2" v-if="d.visitor_details.address != ''">
	                <p class="mb-0 body-2 font-regular text-12">{{$t("hotel.visitor-detail.address")}} :</p>
	                <p class="mb-0 body-2-2 text-14 font-semibold">{{d.visitor_details.address}}</p>
	              </div>
	              <div class="col-6 mb-2" v-if="d.visitor_details.country != ''">
	                <p class="mb-0 body-2 font-regular text-12">{{$t("hotel.visitor-detail.country")}} :</p>
	                <p class="mb-0 body-2-2 text-14 font-semibold">{{d.visitor_details.country}}</p>
	              </div>
	            </div>
	          </template>
	          <!-- Special Request -->
	          <p class="mt-4 mb-2 body-2-2 text-16 font-bold" v-if="is_valid_special_request">{{$t("hotel.special-request.title")}}</p>
	          <div class="row">
	            <div class="col-12 mb-2" v-if="d.special_request_details.length > 0">
	              <div class="row">
	                <div class="col-6" :class="{'col-12':d.special_request_details.length == 1}" v-for="special_request in d.special_request_details">
	                  <img src="../../../assets/img/icon/correct.png" class="position-relative d-inline-block align-top" width="10" style="top: 4px;">
	                  <p class="mb-0 body-2-2 text-12 font-semibold d-inline-block w-75 align-top">{{special_request.name}} <span v-if="special_request.notes != ''">({{special_request.notes}})</span></p>
	                </div>
	              </div>
	            </div>
	            <div class="col-6 mb-2" v-if="d.custom_check_in_time != ''">
	              <p class="mb-0 body-2 font-regular text-12">{{$t("hotel.special-request.request-check-in")}}</p>
	              <p class="mb-0 body-2-2 text-14 font-semibold d-inline-block w-75">{{d.custom_check_in_time}}</p>
	            </div>
	            <div class="col-6 mb-2" v-if="d.custom_check_out_time != ''">
	              <p class="mb-0 body-2 font-regular text-12">{{$t("hotel.special-request.request-check-out")}}</p>
	              <p class="mb-0 body-2-2 text-14 font-semibold d-inline-block w-75">{{d.custom_check_out_time}}</p>
	            </div>
	            <div class="col-12 mb-2" v-if="d.notes != ''">
	              <p class="mb-0 body-2 font-regular text-12">{{$t("hotel.special-request.other-request")}}</p>
	              <p class="mb-0 body-2-2 text-14 font-semibold d-inline-block ">{{d.notes}}</p>
	            </div>
	          </div>
	          <!-- Additional Service -->
	          <template v-if="d.additional_service_details.length > 0">
	          	<p class="mt-4 mb-2 body-2-2 text-16 font-bold">{{$t("hotel.additional-service")}}</p>
	            <div class="row slim-grid-row mb-2" v-for="additional in d.additional_service_details">
	              <div class="col-12 col-mb-12">
	                <p class="mb-0 body-2-2 text-14 font-semibold">{{additional.name}}</p>
	                <p class="mb-0 body-2-2 text-14 font-regular">{{formatCurrency(additional.price)}} / {{additional.unit}}</p>
	                <p class="mb-0 body-2-2 text-14 font-regular">{{additional.qty}}x</p>
	              </div>
	            </div>
	          </template>
	          <!-- Price Detail -->
	          <p class="mt-4 mb-2 body-2-2 text-16 font-bold">{{$t("hotel.payment-method.payment-detail")}}</p>
	          <div class="bg-light border rounded-6 p-3">
		          <div class="row">
		            <div class="col-6 mb-1" v-if="d.payments.total_deposit != 0">
		              <p class="mb-1 body-2-2">{{$t("hotel.payment-method.bank-name")}}</p>
		            </div>
		            <div class="col-6 mb-1" v-if="d.payments.total_deposit != 0">
		              <p class="mb-1 body-2-2">: {{$t("payment-gateway."+d.payment_details.bank_name)}}</p>
		            </div>
		            <div class="col-6 mb-1" v-if="d.payments.total_deposit != 0">
		              <p class="mb-1 body-2-2">{{$t("general.payment-method")}}</p>
		            </div>
		            <div class="col-6 mb-1" v-if="d.payments.total_deposit != 0">
		              <p class="mb-1 body-2-2">: {{$t("payment-gateway-channel."+d.payment_details.payment_method)}}</p>
		            </div>
		            <div class="col-6 mb-1" v-if="d.payments.total_deposit != 0">
		              <p class="mb-1 body-2-2">{{$t("hotel.payment-method.status")}}</p>
		            </div>
		            <div class="col-6 mb-1" v-if="d.payments.total_deposit != 0">
		              <p class="mb-1 body-2-2 font-bold text-12 text-orange" v-if="detail_tx.status == 'WAITING_PAYMENT_CONFIRMATION'">: {{$t("hotel.waiting.waiting-payment")}}</p>
	                <p class="mb-1 body-2-2 font-bold text-green" v-if="detail_tx.status == 'COMPLETE'">: {{$t("hotel.success.success")}}</p>
	                <p class="mb-1 body-2-2 font-bold text-danger" v-if="detail_tx.status == 'CANCELLED'">: {{$t("hotel.failed.failed")}}</p>
		            </div>
		            <div class="col-6 mb-1">
		              <p class="mb-1 body-2-2 font-regular">{{$t("hotel.success.room-charges")}}</p>
		            </div>
		            <div class="col-6 mb-1">
		              <p class="mb-1 body-2-2 font-regular">: {{formatCurrency(d.payments.total_payment - d.payments.total_additional)}}</p>
		            </div>
		            <div class="col-6 mb-1" v-if="d.payments.total_additional > 0">
		              <p class="mb-1 body-2-2 font-regular">{{$t("hotel.additional-service")}}</p>
		            </div>
		            <div class="col-6 mb-1" v-if="d.payments.total_additional > 0">
		              <p class="mb-1 body-2-2 font-regular">: {{formatCurrency(d.payments.total_additional)}}</p>
		            </div>
		            <div class="col-6 mb-1 border-top pt-2">
		              <p class="mb-1 body-2-2 font-bold">{{$t("hotel.total")}}</p>
		            </div>
		            <div class="col-6 mb-1 border-top pt-2">
		              <p class="mb-1 body-2-2 font-bold">: {{formatCurrency(d.payments.total_payment)}}</p>
		            </div>
		            <div class="col-6 mb-1">
		              <p class="mb-2 body-2-2 font-bold">{{ this.$isNotEmptyV2(getMerchant().booking_engine_cart_payable_deposit_label) ? getMerchant().booking_engine_cart_payable_deposit_label : $t('hotel.deposit-due-now')}}</p>
		            </div>
		            <div class="col-6 mb-1">
		              <p class="mb-2 body-2-2 font-bold text-green">: {{formatCurrency(d.payments.total_deposit)}}</p>
		            </div>
		            <div class="col-6 border-top pt-2" v-if="is_deposit_arrival">
		              <p class="mb-0 body-2-2 font-bold text-14">{{ this.$isNotEmptyV2(getMerchant().booking_engine_cart_payable_at_hotel_label) ? getMerchant().booking_engine_cart_payable_at_hotel_label : $t('hotel.deposit-due-on-arrival') }}</p>
		            </div>
		            <div class="col-6 border-top pt-2" v-if="is_deposit_arrival">
		              <p class="mb-0 body-2-2 font-bold text-16 text-orange">: {{formatCurrency(d.payments.total_payment - d.payments.total_deposit)}}</p>
		            </div>
		          </div>
		        </div>
	        </div>
	      </div>
	    </template>
	  </div>
  </div>
</template>
<script>
  import {mapGetters} from 'vuex';
	import {get} from '@/services/index.js';
  import {customFormatDateTime,formatCurrency} from '@/utils/index.js';
  export default{
    components: {
    },
    metaInfo(){
      return {
        title: 'Order History',
        titleTemplate: this.getMetaTitleTemplate()
      }
    },
    data() {
      return {
      	is_load: false,
        scrollPosition: null,
        is_filter: false,
        tx: [],
        error: '',
        detail_tx: '',
        v_status: ['ALL','COMPLETE','WAITING_PAYMENT_CONFIRMATION','CANCELLED'],
        status_selected: "ALL",
        perPage: 10,
        total: 0,
        currentPage: 1,
        lastPage: 3,
        v_sort: ['ASC','DESC'],
        sort_selected: "ASC",
        user:{}
      }
    },
    computed:{
    	d(){
    		return this.detail_tx.data_detail
    	},
    	is_valid_visitor(){
      	let display = false
      	if (this.detail_tx.data_detail.visitor_details.address != '' && this.detail_tx.data_detail.visitor_details.email != '' && this.detail_tx.data_detail.visitor_details.first_name != '' && this.detail_tx.data_detail.visitor_details.phone_number != '') {
      		display = true
      	}
      	return display
      },
      is_valid_special_request(){
        return (this.d.special_request_details.length > 0 || this.d.custom_check_in_time != '' || this.d.custom_check_out_time != '') ? true : false
      },
      is_deposit_arrival(){
      	return this.d.payments.total_payment - this.d.payments.total_deposit > 0 ? true : false
      },
    },
    mounted() {
      window.addEventListener('scroll', this.updateScroll);
      this.scroolUp()
      this.getTxDetail()
      this.loadCurrentUser()
    },
    watch:{
    	currentPage(){
    		this.getTxDetail()
    	},
    	status_selected(){
    		this.currentPage = 1
    	},
    	sort_selected(){
    		this.currentPage = 1
    	}
    },
    methods: {
      ...mapGetters(['getMerchant','isNotLogin','getCurrentUser','getMetaTitleTemplate']),
      scroolUp(){
      	document.getElementById('hotel-history').scrollIntoView({
	        behavior: 'smooth'
	      });
      },
      updateScroll() {
        this.scrollPosition = window.scrollY
      },
      isFilter(){
        this.is_filter = !this.is_filter
      },
      formatCurrency(value){
        return formatCurrency(value);
      },
      formatDate(date) {
        return customFormatDateTime(date, null, 'ddd, DD MMM YYYY')
      },
      toggleFilter(event){
    		this.status_selected = event
    		this.getTxDetail()
      },
      toggleSort(event){
    		this.sort_selected = event
    		this.getTxDetail()
      },
      loadCurrentUser(){
      	this.is_load = true
      	get("BASE","auth/profile").then(response=>{
      		let res = response.data.user
      		this.user = res
	      	this.is_load = false
      	})
      },
      getTxDetail(){
      	this.is_load = true
      	let params = {
      		status: this.status_selected,
      		datetime_type: 'NO_USE_FILTER_DATE',
      		start_datetime: '2021-03-26 00:00:00',
      		end_datetime: '2021-04-27 00:00:00',
      		merchant_id : this.getMerchant().id,
      		invoice: '',
      		order_type: this.sort_selected,
      		page: this.currentPage,
      		page_size: this.perPage
      	}
      	get("CORE_HOTEL","tx-hiztory",params).then(response=>{
      		let res = response.data
      		if (res.success == false) {
      			this.error == res.message
      		}else{
      			this.tx = res.data
      			this.lastPage = res.last_page
      			this.perPage = res.per_page
      			this.total = res.total
      		}
      		this.is_load = false
      	})
      },
      detailTx(data){
      	this.detail_tx = data
      	this.scroolUp()
      }
    },
  }
</script>
<style scoped>
@media screen and (max-width: 655px) {
  .mobile-none{
    display: none !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/hotel/be/BeOrderHistory.vue